/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState, useMemo } from 'react';
// import Grid from "./gridComponents/grid";
import { useDispatch, useSelector } from 'react-redux';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import Grid from '../../../../SharedModules/Table/TableGridWithFeatures';
import LinksButtonRender from './linksButtonRender';
import { getInvoiceQuarterTotals } from '../store/actions';
import { invoiceQuarterTotalsCells } from './gridComponents/tableHead';
import CustomGridCellRendererComponent from '../../../../SharedModules/AgGridUtilities/CustomGridCellRenderercomponent';

export default function InvoiceQuarterTotalsTab(props) {
  const dispatch = useDispatch();
  const [keyValue, setKeyValue] = useState([]);
  const [showViewHistory, setShowViewHistory] = useState(false);
  const [filterApply, setFilterApply] = React.useState(false);
  const [filteredRows, setFilteredRow] = React.useState([]);
  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };
  const invoiceQuarter = useSelector(
    (state) => state.sharedState.DisplayInvoiceReducer.invoiceQuarter
  );
  const frameworkComponents = {
    LinksButtonRender: LinksButtonRender,
  };
  const { invoiceDetailsByInvoiceNum, setFullScreenView, fullScreenView } =
    props;

  const invoiceQuarterTotals = useSelector(
    (state) =>
      state.sharedState.DisplayInvoiceReducer.invoiceQuarterTotals?.data
  );

  useEffect(() => {
    if (!invoiceQuarterTotals?.length > 0) {
      dispatch(
        getInvoiceQuarterTotals({
          invoiceNum: invoiceDetailsByInvoiceNum?.invoiceNum,
          rebateProgramCd: invoiceDetailsByInvoiceNum?.rebateProgramCd,
        })
      );
    }
  }, []);

  // Total Count on Table Cells Starts
  const sum = (property) => {
    const displayedRows = filterApply ? filteredRows : invoiceQuarterTotals;
    const data = displayedRows?.reduce((accumulator, object) => {
      return accumulator + object[property];
    }, 0);

    return Math.round(100 * data) / 100;
  };

  const createData = (count) => {
    const result = [];
    for (let i = 0; i < count; i += 1) {
      result.push({
        rowPinned: true,
        isBottomRow: true,
        ctotOrigInvAmt: sum('ctotOrigInvAmt'),
        ctotRevInvAmt: sum('ctotRevInvAmt'),
        ctotPpAmt: sum('ctotPpAmt'),
        ctotPrincipalDue: sum('ctotPrincipalDue'),
        ctotIntDue: sum('ctotIntDue'),
        ctotTotalDue: sum('ctotTotalDue'),
      });
    }
    return result;
  };
  const onFilterChanged = (rowData, type) => {
    const updatedRowData = rowData.map((item) => {
      return {
        ...item,
      };
    });
    setFilteredRow(updatedRowData);
  };
  const pinnedBottomRowData = useMemo(() => {
    return createData(1, 'Bottom');
  }, [invoiceQuarterTotals, filteredRows, filterApply]);

  const handleFullScreenViewClick = () => {
    setFullScreenView(!fullScreenView);
  };

  const handleViewHistory = (gridApi) => {
    const selectedRow = gridApi.getSelectedRows()?.[0];
    if (selectedRow !== undefined) {
      setShowViewHistory(true);
      setKeyValue({
        INVOICE_NUM: `${invoiceDetailsByInvoiceNum?.invoiceNum}`,
        // PREV_QTR: `${selectedRow?.prevQtr}`,
      });
    }
  };

  // Total Count on Table Cells Ends

  return (
    <>
      <div style={{ marginTop: '0px' }}>
        <Grid
          pinnedBottomRowData={pinnedBottomRowData}
          onFilterData={onFilterChanged}
          getFilterApply={getFilterApply}
          gridHeight={fullScreenView ? '100vh' : 350}
          rowData={invoiceQuarterTotals || []}
          fullScreenView={fullScreenView}
          columnDefs={invoiceQuarterTotalsCells}
          data-testid="onEditingStopped"
          enterMovesDown
          suppressCellFocus
          onCellFocused={onCellFocused}
          singleClickEdit={false}
          navigateToNextCell={navigateToNextCell}
          // tabToNextCell={tabToNextCell}
          handleFullScreenViewClick={handleFullScreenViewClick}
          exportFile
          // isScrollOn
          fileName="Quarter Totals"
          // handleViewHistory={handleViewHistory}
          frameworkComponents={{
            frameworkComponents,
            AmountComponent: CustomGridCellRendererComponent,
            UnitRebateAmtCellRender: (cellInfo) => {
              const value = parseFloat(cellInfo?.value);
              if (cellInfo?.data?.isBottomRow) {
                const pinnedValue = parseFloat(cellInfo?.value);
                if (pinnedValue < 0) {
                  return (
                    <b>
                      <span style={{ color: '#eb0000' }}>
                        (
                        {` ${Math.abs(parseFloat(pinnedValue)).toLocaleString(
                          'en-US',
                          {
                            minimumFractionDigits: 6,
                            maximumFractionDigits: 6,
                          }
                        )}`}
                        )
                      </span>
                    </b>
                  );
                }
                if (pinnedValue) {
                  return (
                    <b>
                      {` ${parseFloat(pinnedValue)?.toLocaleString('en-US', {
                        minimumFractionDigits: 6,
                        maximumFractionDigits: 6,
                      })}`}
                    </b>
                  );
                }
                return <b> 0.000000</b>;
              }
              if (value < 0) {
                return (
                  <span style={{ color: '#eb0000' }}>
                    (
                    {Math.abs(parseFloat(value)).toLocaleString('en-US', {
                      minimumFractionDigits: 6,
                      maximumFractionDigits: 6,
                    })}
                    )
                  </span>
                );
              }
              if (value) {
                return ` ${parseFloat(value)?.toLocaleString('en-US', {
                  minimumFractionDigits: 6,
                  maximumFractionDigits: 6,
                })}`;
              }
              return ' 0.000000';
            },
            NumOfUnitsCellRender: (cellInfo) => {
              const value = parseFloat(cellInfo?.value);
              if (cellInfo?.data?.isBottomRow) {
                const pinnedValue = parseFloat(cellInfo?.value);
                if (pinnedValue < 0) {
                  return (
                    <b>
                      <span style={{ color: '#eb0000' }}>
                        (
                        {` ${Math.abs(parseFloat(pinnedValue)).toLocaleString(
                          'en-US',
                          {
                            minimumFractionDigits: 4,
                            maximumFractionDigits: 4,
                          }
                        )}`}
                        )
                      </span>
                    </b>
                  );
                }
                if (pinnedValue) {
                  return (
                    <b>
                      {` ${parseFloat(pinnedValue)?.toLocaleString('en-US', {
                        minimumFractionDigits: 4,
                        maximumFractionDigits: 4,
                      })}`}
                    </b>
                  );
                }
                return <b> 0.0000</b>;
              }
              if (value < 0) {
                return (
                  <span style={{ color: '#eb0000' }}>
                    (
                    {Math.abs(parseFloat(value)).toLocaleString('en-US', {
                      minimumFractionDigits: 4,
                      maximumFractionDigits: 4,
                    })}
                    )
                  </span>
                );
              }
              if (value) {
                return ` ${parseFloat(value)?.toLocaleString('en-US', {
                  minimumFractionDigits: 4,
                  maximumFractionDigits: 4,
                })}`;
              }
              return ' 0.0000';
            },
          }}
        />
        {showViewHistory ? (
          <ViewHistoryComponent
            setShowViewHistory={setShowViewHistory}
            tableName="INVOICE_HEADER"
            keyValue={keyValue}
          />
        ) : null}
      </div>
    </>
  );
}
